export const HomeRoutesConfig = {
  homePage: "/home",
} as const;
